define('lib/Podio.UI.Header.Counters',['require','underscore','jquery','lib/Podio.Push','lib/Podio.Favicon','views/lib/Podio.Views.SlotMachineCount','jst!layouts/_header_count_v2','lib/Podio.Utils'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var PodioPush = require('lib/Podio.Push');
  var PodioFavIcon = require('lib/Podio.Favicon');
  var SlotMachineCountView = require('views/lib/Podio.Views.SlotMachineCount');
  var jstHeaderCount = require('jst!layouts/_header_count_v2');
  var podioUtils = require('lib/Podio.Utils');

  function HeaderCounters() {
    var elmHeaderGlobal = $('#header-global');

    this.elmChat = elmHeaderGlobal.find('.podio-chat');
    this.elmInbox = elmHeaderGlobal.find('.user-functions .inbox');

    this.currentNotificationsCount = this.elmInbox.data('count') || 0;
    this.currentConversationsCount = this.elmChat.data('count') || 0;
  }

  _.extend(HeaderCounters.prototype, {

    initialize: function() {
      _.bindAll(this, 'onConversationUnreadCountChanged', 'onNotificationUnreadCountChanged');
      this._bindEvents();

      this.updateCount();
    },

    _bindEvents: function() {
      PodioPush.on('user', 'notification_unread', this.onNotificationUnreadCountChanged);
      PodioPush.on('user', 'conversation_unread_count', this.onConversationUnreadCountChanged);
    },

    _handleZeroCountForCounters: function(count, view) {

      // Handle the disposing of the current view if count===0 and acts as a condition if the count should be rendered or not.

      if(count === 0){
        if(view) {
          view.dispose();
        }
        return false;
      }

      return true;

    },

    getCurrentCommonCount: function() {
      return this.currentNotificationsCount + this.currentConversationsCount;
    },

    getNotificationsCount: function() {
      return this.currentNotificationsCount;
    },

    getConversationsCount: function() {
      return this.currentConversationsCount;
    },

    updateFluidBadge: function(count) {
      if (window.fluid) {
        window.fluid.dockBadge = (count > 0) ? count : '';
      }
    },

    renderConversationsCount: function() {
      var count = this.currentConversationsCount;
      this.elmChat.data('count', count);

      var iconClass = 'icon-chat';
      if (count > 0) {
        //TODO - replace icon class during icon changes
        iconClass = 'icon-chat-with-count';
      }

      var html = jstHeaderCount({
        iconClass: 'icon-16 icon-regular {0}'.format(iconClass),
        hoverIcon: 'icon-16 icon-hover {0}'.format(count > 0 ? 'icon-nav-white-chat-new' : 'icon-nav-white-chat')
      });

      this.elmChat.find('.icon').html(html);

      if(this._handleZeroCountForCounters(count, this.conversationsCountView)) {

        // Slot Machine Counter
        if(!this.conversationsCountView) {
          this.conversationsCountView = new SlotMachineCountView({
            count: count
          });
        }

        var elmCounter = this.elmChat.find('.counter');
        this.conversationsCountView.updateElementReference(elmCounter);
        this.conversationsCountView.render(count);

      }

    },

    renderInboxCount: function() {
      if (!podioUtils.showFeature('old_notification_dropdown')) {
        return;
      }

      var count = this.currentNotificationsCount;
      this.elmInbox.data('count', count);

      var anchor = this.elmInbox.find('a').eq(0);
      if (anchor) {
        anchor.attr('aria-label', (anchor.attr('aria-label') || '').replace(/^(?:\d+ )?/, count ? count + ' ' : ''));
      }

      var html, iconClass, hoverIconClass;

      iconClass = 'icon-nav-blue-notifications';
      hoverIconClass = 'icon-nav-white-notifications';
      if (count > 0) {
        iconClass = 'icon-nav-white-notifications-new';
        hoverIconClass = 'icon-nav-white-notifications-new';
      }
      else if (this.elmInbox.hasClass('selected')) {
        iconClass = 'icon-nav-white-notifications';
      }

      html = jstHeaderCount({
        count: count,
        iconClass: 'icon-nav icon-regular {0}'.format(iconClass),
        hoverIcon: 'icon-nav icon-hover {0}'.format(hoverIconClass)
      });

      this.elmInbox.find('a').eq(0).html(html);

      if(this._handleZeroCountForCounters(count, this.notificationsCountView)) {

        // Slot Machine Counter
        if(!this.notificationsCountView) {
          this.notificationsCountView = new SlotMachineCountView({
            count: count
          });
        }

        var elmCounter = this.elmInbox.find('.counter');
        this.notificationsCountView.updateElementReference(elmCounter);
        this.notificationsCountView.render(count);

      }

    },

    updateCount: function() {
      var count = this.getCurrentCommonCount();

      // Rendering
      this.renderInboxCount();
      this.renderConversationsCount();

      // Update icon
      PodioFavIcon.setCount(count);

      // Update Fluid Badge
      this.updateFluidBadge(count);
    },

    updateNotificationsCount: function(count) {
      this.currentNotificationsCount = count;
      this.updateCount();
    },

    updateConversationsCount: function(count) {
      this.currentConversationsCount = count;
      this.updateCount();
    },

    onConversationUnreadCountChanged: function(pushData) {
      this.updateConversationsCount(pushData.count);
    },

    onNotificationUnreadCountChanged: function(pushData) {
      this.updateNotificationsCount(pushData.count);
    }

  });

  var headerCountersInstance = new HeaderCounters();

  return headerCountersInstance;

});

